import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";

import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import PropTypes from "prop-types";

import BiodataViewFields from "./components/BiodataViewFields";
import { useTranslation } from "react-i18next";


const Profilebiodata = (prop) => {
  // const history = useHistory();
  const { history } = prop;

  const location = useLocation();
  const profile = location.state?.profile;

  const { t } = useTranslation();

  // Redirect back if there's no profile data
  if (!profile) {
    history.push("/");
    return <p>Redirecting...</p>;
  }



  return (
    <>
      <>
        <div >
        
        
          {/* Page Wrapper */}
          <div className="mt-3">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="content-page-header">
                  <h5>{t("Profile Biodata")}</h5>

                </div>
              </div>
              {/* /Page Header */}
              <div className="card ledger-list">
            
                {/* Table */}
                <FDWProfilePresentation profile={profile} />
                {/* /Table */}
              </div>
              <>
              </>
            </div>
          </div>

          {/* /Page Wrapper */}
        </div>

   
      </>
    </>
  );
};
const FDWProfilePresentation = ({ profile }) => {


  




  const data = profile;





  const [colorClassStatus, setColorClassStatus] = useState("")






  const [statusBiodata, setStatusBiodata] = useState(profile.status)
 


  useEffect(() => {

    if (!statusBiodata) return;

    if (statusBiodata === "Published") {
      setColorClassStatus("bg-success-light");
    } else if (statusBiodata === "Draft") {
      setColorClassStatus("bg-info text-white");
    } else if (statusBiodata === "On-Hold") {
      setColorClassStatus("bg-gradient-light border round");
    } else if (statusBiodata === "Unavailable") {
      setColorClassStatus("bg-dark text-white");
    } else {
      setColorClassStatus(""); // default/fallback
    }
  }, [statusBiodata]);

 


  return (
    <div className="biodataprofile my-5">

<BiodataViewFields profile={profile} >
    

      

      <div className="d-flex justify-content-between align-items-baseline mb-4 mx-2">

        {/** buttons */}
     
          <div className="dropdown">
            <button
              className={`btn ${colorClassStatus}`}
              type="button"
            
           
      
            >
              {statusBiodata}
          </button>

     </div> </div>




    </BiodataViewFields>
    </div>
  );
};





FDWProfilePresentation.propTypes = {
  profile: PropTypes.object.isRequired,
};


export default Profilebiodata;
